import React, { useState } from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import StatusSelect from '#components/m/StatusSelect'
import Text from '#components/a/Text'
import Loading from '#components/a/Loading'
import Pagination from '#components/m/Pagination'

export function PraxisaufgabenCollection(props) {
  const {azubis, canViewPraxisaufgabenFromOthers, style, placeholderTextId, testid} = props

  const isLoading = !azubis

  if (isLoading) {
    return <Loading />
  }
  
  const [visibleAzubis, setVisibleAzubis] = useState([])
  const scroll = (skip, take) => {
    setVisibleAzubis(azubis.slice(skip, skip+take))
  }

  return (
    <>
      <Pagination data={azubis} scrollCallback={scroll}/>
      <div className="praxisaufgaben-overview--collection" style={style} data-testid={testid}>
        {visibleAzubis.map(azubi => (
          <StatusSelect key={azubi.id} canViewPraxisaufgabenFromOthers={canViewPraxisaufgabenFromOthers} user={azubi} />
        ))}
        {azubis && azubis.length === 0 && <Text text={i18n.t(placeholderTextId)} />}
      </div>
    </>
  )
}

PraxisaufgabenCollection.propTypes = {
  azubis: PropTypes.array,
  canViewPraxisaufgabenFromOthers: PropTypes.bool,
  style: PropTypes.object,
  placeholderTextId: PropTypes.string.isRequired,
  testid: PropTypes.string,
}
